import React from 'react';
import PropTypes from 'prop-types';
import Layout from 'sushiweb/Layout';
import Checkbox from 'sushiweb/InputTypes/Checkbox';

import { infoLabels } from '../../../../WalletPrograms/constants';
import SelectItems from '../../../../../components/SelectItems';
import {
  InputWrapper,
  FormWrapper,
  NeverEnd,
  HelperTextWrapper,
  StyledInput,
  StyledLayout,
  DateTimeInput,
} from '../../../styles';
import {
  minStartDate,
  maxStartDate,
  handleStartDateChange,
  handleEndDateChange,
  handleProgramNameChange,
  handleNeverEndCheck,
  handleProgramStartTimeChange,
  getDateFromString,
} from '../../helpers/inputHandlers';

const PlanSnippet = ({
  formData,
  updateFormData,
  updateSelectedGroups,
  updateUnSelectedGroups,
  allGroups,
  planDataFlag,
  adjustBackgroundHeight,
}) => {
  return (
    <FormWrapper>
      <StyledLayout gap={20}>
        <Layout.Item colD={12} colT={12} colM={12}>
          <InputWrapper>
            <StyledInput
              value={formData?.name}
              innerWidth='100%'
              label='Meal plan name'
              onChange={handleProgramNameChange(updateFormData)}
              errorMsg={formData?.nameErrMsg}
              disabled={planDataFlag}
            />
          </InputWrapper>
        </Layout.Item>
        <Layout.Item colD={4} colT={12} colM={12}>
          <InputWrapper>
            <DateTimeInput
              label='Start date'
              innerWidth='100%'
              type='date'
              value={getDateFromString(formData?.startDate)}
              min={minStartDate}
              max={maxStartDate}
              onChange={handleStartDateChange(updateFormData)}
              disabled={planDataFlag}
            />
          </InputWrapper>
        </Layout.Item>
        <Layout.Item colD={4} colT={12} colM={12}>
          <InputWrapper>
            <DateTimeInput
              label='Start Time'
              innerWidth='97%'
              type='time'
              value={formData?.startTime}
              onChange={handleProgramStartTimeChange(updateFormData)}
              showHelperText
              disabled={planDataFlag}
            />
          </InputWrapper>
        </Layout.Item>
        <Layout.Item colD={4} colT={12} colM={12}>
          <InputWrapper>
            <DateTimeInput
              label='End date'
              innerWidth='100%'
              type='date'
              value={
                formData?.neverEnd ? '' : getDateFromString(formData?.endDate)
              }
              onChange={handleEndDateChange(updateFormData)}
              disabled={formData?.neverEnd || planDataFlag}
            />
          </InputWrapper>
        </Layout.Item>
        <Layout.Item colD={8} colT={6} colM={6}>
          <HelperTextWrapper>{infoLabels.startDateV2}</HelperTextWrapper>
        </Layout.Item>
        <Layout.Item colD={3} colT={3} colM={3}>
          <HelperTextWrapper>{infoLabels.endDate}</HelperTextWrapper>
        </Layout.Item>
        <Layout.Item colD={1} colT={3} colM={3}>
          <NeverEnd>
            <NeverEnd.RightContainer>
              <Checkbox
                checked={formData?.neverEnd}
                onChange={handleNeverEndCheck(updateFormData, formData)}
                label='Never end'
                color='#9197A6'
                disabled={planDataFlag}
              />
            </NeverEnd.RightContainer>
          </NeverEnd>
        </Layout.Item>
        <Layout.Item
          colD={12}
          colT={12}
          colM={12}
          style={{ position: 'relative' }}
        >
          <InputWrapper>
            <SelectItems
              allItems={allGroups}
              selectedItems={formData?.selectedGroups}
              unSelectedItems={formData?.unSelectedGroups}
              updateSelectedItems={updateSelectedGroups}
              updateUnSelectedItems={updateUnSelectedGroups}
              placeholder='Assign to team(s)'
              disabled={planDataFlag}
              tagType='grey'
              adjustBackgroundHeight={adjustBackgroundHeight}
            />
          </InputWrapper>
        </Layout.Item>
      </StyledLayout>
    </FormWrapper>
  );
};

PlanSnippet.propTypes = {
  formData: PropTypes.shape({
    name: PropTypes.string,
    nameErrMsg: PropTypes.string,
    startDate: PropTypes.string,
    startTime: PropTypes.string,
    endDate: PropTypes.string,
    neverEnd: PropTypes.bool,
    selectedGroups: PropTypes.arrayOf(PropTypes.object),
    unSelectedGroups: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  updateFormData: PropTypes.func.isRequired,
  updateSelectedGroups: PropTypes.func.isRequired,
  updateUnSelectedGroups: PropTypes.func.isRequired,
  allGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
  planDataFlag: PropTypes.bool,
  adjustBackgroundHeight: PropTypes.bool,
};

PlanSnippet.defaultProps = {
  planDataFlag: false,
  adjustBackgroundHeight: false,
};

export default PlanSnippet;
